import React, { useState } from "react";

import { Button, Stack } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import dayjs, { Dayjs } from "dayjs";
import { useDateFormatSelect } from "store";
import toIsoMidday from "utils/to-iso-midday";

interface Props {
  currentDate: string | null;
  onSubmit: (result: { effectiveDate: string | null }) => void;
  onCancel: () => void;
}

export const EffectiveDatePrompt: React.FC<Props> = ({ currentDate, onSubmit, onCancel }) => {
  const dateFormat = useDateFormatSelect();
  const [value, setValue] = useState<Dayjs | null>(currentDate ? dayjs(currentDate) : null);

  return (
    <Stack sx={{ padding: "24px", gap: "20px", minWidth: "427px" }}>
      <DesktopDatePicker
        label="Effective Date"
        value={value}
        onChange={(newValue) => setValue(newValue)}
        format={dateFormat}
        slotProps={{
          field: { clearable: true, onClear: () => setValue(null) }
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            borderRadius: "8px",
            "& fieldset": { borderColor: "#7b92a9" }
          }
        }}
      />
      <Stack direction="row" justifyContent="flex-end" gap="8px">
        <Button
          onClick={onCancel}
          sx={{
            borderRadius: "32px",
            border: "1px solid #7b92a9",
            color: "#071f35",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px"
          }}
        >
          Cancel
        </Button>
        <Button
          onClick={() => {
            onSubmit({ effectiveDate: value?.isValid() ? toIsoMidday(value) : null });
          }}
          sx={{
            borderRadius: "32px",
            bgcolor: "#071f35",
            color: "white",
            textTransform: "none",
            padding: "4px 16px",
            fontSize: "16px",
            fontWeight: 400,
            lineHeight: "24px",
            "&:hover": { bgcolor: "#0a2a45" },
            "&:disabled": { bgcolor: "#bac7ce", color: "white" }
          }}
        >
          Add
        </Button>
      </Stack>
    </Stack>
  );
};
